import { z } from 'zod/v4'

export const sortOrderSchema = z.enum(['ascend', 'descend'])
